import axios from '@/libs/api.request'
// 提交推荐信息
export const subRecommendCreate = data => {
  return axios.request({
    url: '/recommend/create',
    data,
    method: 'POST'
  })
}
// 获取推荐的list
export const getRecommendList = data => {
  return axios.request({
    url: '/recommend/list',
    data,
    method: 'POST'
  })
}
